<template>
    <div class="services-landing__second-level-desktop-wrapper">
        <ul>
            <template v-for="(item, index) in items" :key="index">
                <li class="services-landing__second-level-desktop-item" :id="item.id" @click="setActive(item)">
                    <span class="services-landing__second-level-desktop-item-inner" :class="{
                        'services-landing__second-level-desktop-item-inner--active':
                            active && active.id === item.id,
                    }" v-if="item.children.length > 0">
                        {{ item.title }} ({{ item.children.length }})
                    </span>
                    <span class="services-landing__second-level-desktop-item-inner" :class="{
                        'services-landing__second-level-desktop-item-inner--active':
                            active && active.id === item.id,
                    }" v-else>
                        <span>{{ item.title }}</span>
                    </span>
                    <span class="services-landing__translations" v-if="item.hasCulture">{{
                        item.translationsAvailableLabel }}</span>
                </li>
            </template>
        </ul>
    </div>
    <div class="services-landing__third-level-desktop-wrapper" v-if="active && active.children.length > 0">
        <ServicesThirdLevelDesktop :items="active.children" />
    </div>
</template>

<script>
import ServicesThirdLevelDesktop from "./ServicesThirdLevelDesktop.vue";
import { store } from "../../store.js";

export default {
    props: ["items"],
    components: {
        ServicesThirdLevelDesktop,
    },
    data() {
        return {
            active: null,
        };
    },
    computed: {
        activeAlpha: function () {
            return store.serviceActiveAlpha;
        },
    },
    watch: {
        items: function () {
            this.$nextTick(() => {
                this.active = null;
                store.serviceOverview = null;
            });
        },
    },
    methods: {
        setActive: function (item) {
            this.active = item;
            store.serviceOverview = item;
            this.$nextTick(() => {
                var element = document.querySelector(".services__overview");
                if (!element) return; // If the element doesn't exist, do nothing

                var headerOffset = 100;
                var elementPosition = element.getBoundingClientRect().top;
                var offsetPosition =
                    elementPosition + window.pageYOffset - headerOffset;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: "smooth",
                });
            });
        },
    },
};
</script>
